/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.linkPicker.button.cancel': 'Cancelar',
  'fabric.linkPicker.button.insert': 'Inserir',
  'fabric.linkPicker.button.save': 'Salvar',
  'fabric.linkPicker.clearLink': 'Limpar',
  'fabric.linkPicker.clearLinkText': 'Limpar texto',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {nenhum resultado encontrado} one {{count,number} resultado encontrado} other {{count,number} resultados encontrados}}',
  'fabric.linkPicker.linkAriaLabel': 'Digite ou cole o link no campo',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Texto auxiliar de exibição do link',
  'fabric.linkPicker.linkHelperTextLabel': 'Dê um título ou uma descrição a este link',
  'fabric.linkPicker.linkInvalid': 'Informe uma URL válida.',
  'fabric.linkPicker.linkLabel': 'Link',
  'fabric.linkPicker.linkPlaceholder': 'Cole o link',
  'fabric.linkPicker.linkTextAriaLabel': 'Texto para exibição do link',
  'fabric.linkPicker.linkTextLabel': 'Texto para exibição (opcional)',
  'fabric.linkPicker.linkTextPlaceholder': 'Texto a ser exibido',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Visualizado recentemente',
  'fabric.linkPicker.listTitle.results': 'Resultados',
  'fabric.linkPicker.search.error.description': 'Atualize a página ou fale com o <a>Suporte da Atlassian</a> se o erro persistir.',
  'fabric.linkPicker.search.error.heading': 'Houve alguns problemas ao carregar os dados.',
  'fabric.linkPicker.search.error.retry': 'Atualizar',
  'fabric.linkPicker.search.linkAriaLabel': 'As sugestões vão aparecer abaixo à medida que você digita no campo',
  'fabric.linkPicker.search.linkLabel': 'Pesquise ou cole o link',
  'fabric.linkPicker.search.linkPlaceholder': 'Encontre links recentes ou cole um link novo',
  'fabric.linkPicker.search.noResults.description': 'Tente de novo usando outro termo.',
  'fabric.linkPicker.search.noResults.heading': 'Não foi possível encontrar nenhum resultado para a pesquisa.',
  'fabric.linkPicker.status.submitting': 'Enviando',
  'fabric.linkPicker.time.message.updated': 'Última atualização: {time}',
  'fabric.linkPicker.time.message.viewed': 'Última visualização: {time}',
  'fabric.linkPicker.unhandledError.description': 'Tente recarregar a página.',
  'fabric.linkPicker.unhandledError.heading': 'Algo deu errado!'
};